import { LlmHistoryNode } from '@adaptiva/ai/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'adaIsLlmNodeExpanded'
})
export class IsLlmNodeExpandedPipe implements PipeTransform {

	public transform(_node: LlmHistoryNode, _collapsedIds: Set<string>): boolean {
		return !_collapsedIds.has(_node.nodeId);
	}

}
